import Picture from "./picture";
import Skeleton from "./skeleton-loading";

const PicturesGrid = ({ loading, pictures, onClick = () => undefined, loadingCount = 8 }) => (
  <div className="grid auto-rows-[200px] grid-cols-2 gap-1 sm:auto-rows-[300px] sm:grid-cols-3 sm:gap-2 md:grid-cols-3 md:gap-2 lg:grid-cols-4 lg:gap-8">
    {loading
      ? Array.from(Array(loadingCount).keys()).map((i) => <Skeleton key={i} height="100%" width="100%" />)
      : pictures?.map((picture, i) => (
          <Picture
            width={420}
            height={420}
            key={picture._id}
            picture={picture}
            objectFit="cover"
            priority={i < 12}
            alt={picture.alt}
            title={picture.alt}
            onClick={() => onClick(picture)}
            className="cursor-pointer md:rounded-sm"
          />
        ))}
  </div>
);

export default PicturesGrid;
